/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { FinanceProposalRequestToLender } from '../models/FinanceProposalRequestToLender';
import type { FinanceProposalResponseFromLender } from '../models/FinanceProposalResponseFromLender';
import type { FinanceProposalWorkflowState } from '../models/FinanceProposalWorkflowState';
import type { PrintData } from '../models/PrintData';
import type { ProposalResponseModel } from '../models/ProposalResponseModel';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class ProposalLenderService {

  /**
   * @param dealId 
   * @returns FinanceProposalWorkflowState Success
   * @throws ApiError
   */
  public static getFinanceProposalsByDealState(
dealId: number,
): CancelablePromise<FinanceProposalWorkflowState> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/finance-proposals/by-deal/{dealId}/state',
      path: {
        'dealId': dealId,
      },
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param dealId 
   * @returns ProposalResponseModel Success
   * @throws ApiError
   */
  public static postFinanceProposalsByDealSubmitionStateRequest(
dealId: number,
): CancelablePromise<ProposalResponseModel> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/finance-proposals/by-deal/{dealId}/submition-state-request',
      path: {
        'dealId': dealId,
      },
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param dealId 
   * @returns any Created
   * @throws ApiError
   */
  public static postFinanceProposalsByDealPrepare(
dealId: number,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/finance-proposals/by-deal/{dealId}/prepare',
      path: {
        'dealId': dealId,
      },
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param dealId 
   * @returns any Accepted
   * @throws ApiError
   */
  public static postFinanceProposalsByDealSubmit(
dealId: number,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/finance-proposals/by-deal/{dealId}/submit',
      path: {
        'dealId': dealId,
      },
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param dealId 
   * @returns PrintData Success
   * @throws ApiError
   */
  public static getFinanceProposalsByDealPrint(
dealId: number,
): CancelablePromise<PrintData> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/finance-proposals/by-deal/{dealId}/print',
      path: {
        'dealId': dealId,
      },
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param dealId 
   * @returns FinanceProposalRequestToLender Success
   * @throws ApiError
   */
  public static getFinanceProposalsByDealLenderRequest(
dealId: number,
): CancelablePromise<FinanceProposalRequestToLender> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/finance-proposals/by-deal/{dealId}/lender-request',
      path: {
        'dealId': dealId,
      },
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param dealId 
   * @returns FinanceProposalResponseFromLender Success
   * @throws ApiError
   */
  public static getFinanceProposalsByDealLenderResponse(
dealId: number,
): CancelablePromise<FinanceProposalResponseFromLender> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/finance-proposals/by-deal/{dealId}/lender-response',
      path: {
        'dealId': dealId,
      },
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

}
